import {Backoffice} from "@one-commerce/sdk-shared";

import {ContextCallClass} from "../utils";

export class AddToCartContext extends ContextCallClass implements Backoffice.Context.AddToCart {
  productId: string;
  cartId: string | null;
  offerId: string | null;
  warehouses: Array<any>;
  warehouseId: string;
  meta: unknown;
  pluginProductLines: Array<any>;
  productLines: Array<any>;
  productAmount: number;
  closePlugin(): Promise<void> {
    return this.call('closePlugin')
  }
  closePluginAndAddToCart(): Promise<void> {
    return this.call('closePluginAndAddToCart')
  }
  closePluginAndRefreshCart(): Promise<void> {
    return this.call('closePluginAndRefreshCart')
  }
}

export class DocumentsContext extends ContextCallClass implements Backoffice.Context.Documents {
  orderDetails?: {
    orderId: string | number,
    orderNumber: string | number,
    paymentMethodId: string | number,
    paymentStatus: string,
    clientId: string | number,
    shipments: Array<any>,
    price: any,
  };
  invoiceDetails?: {
    number: string | number,
    isPaid: boolean,
    leftToPay: number,
    amountPaid: number,
    clientId: string | number,
    totalPrices: any
  };
  selectedInvoices?: [{
    number: string | number,
    isPaid: boolean,
    leftToPay: number,
    amountPaid: number,
    clientId: string | number,
    totalPrices: any,
  }];
  clientContextId?: string | number;
  operatorId?: string | number;
  meta: unknown;
  closePlugin(): Promise<void> {
    return this.call('closePlugin')
  }
  closePluginAndRefreshView(): Promise<void> {
    return this.call('closePluginAndRefreshView')
  }
}

export class EditProductLinesOnCartContext extends ContextCallClass implements Backoffice.Context.EditProductLinesOnCart {
  productId: string;
  cartId: string | null;
  offerId: string | null;
  warehouses: Array<any>;
  warehouseId: string;
  meta: unknown;
  productLineId: string;
  productLines: Array<any>;
  pluginProductLines: Array<any>;
  productAmount: number;
  closePlugin(): Promise<void> {
    return this.call('closePlugin')
  }
  closePluginAndRefreshCart(): Promise<void> {
    return this.call('closePluginAndRefreshCart')
  }
}

export type BackofficeAvailableContext = AddToCartContext | EditProductLinesOnCartContext
